import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SensorAssignment } from '../models/sensorAssignment.model';
import { GridService } from '../shared/grid/grid.service';
import { LabResult, TaskContributionRequest } from '../models/exposureRequest.model';
import { NodeParameterTypeRequestModel } from '../models/nodeRecords.model';

@Injectable({
  providedIn: 'root'
})
export class SensorAssignmentService extends GridService<SensorAssignment> {

  constructor(http: HttpClient) {
    super("SensorAssignment", http);
  }

  getLabResults(sensorAssignmentId: string, parameterId?: string) {
    let params = new HttpParams().set('sensorAssignmentId', sensorAssignmentId);

    if (parameterId !== undefined && parameterId !== null) {
      params = params.set('parameterId', parameterId.toString());
    }

    return this.http.get<LabResult[]>(
      this.getApiUrl(`${this.controllerName}/GetLabResults`),
      { params });
  }

  getNodeParameterTypes(payload: NodeParameterTypeRequestModel) {
    return this.http.post<number[]>(this.getApiUrl(`${this.controllerName}/GetNodeParameterTypes`), payload);
  }

  patchEndDate(id: string, payload: {}) {
    return this.http.patch(this.getApiUrl(`${this.controllerName}/Patch/${id}`), payload);
  }

  calculateTaskContributions(exposureRequest: TaskContributionRequest) {
    return this.http.post<any[]>(this.getApiUrl(`${this.controllerName}/CalculateTaskContributions`), exposureRequest);
  }
}
